module.exports = __webpack_public_path__ + "img/m3.4c6afbabe37e08ce966a66dc5031375c.png";